import { fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import type { User } from "../../types/user";

export const getUser = async (): Promise<User | null> => {
	try {
		const user = await getCurrentUser();
		const attributes = await fetchUserAttributes();

		return {
			...user,
			email: attributes.email,
		};
	} catch (error) {
		// biome-ignore lint/suspicious/noConsole: <explanation>
		console.error(error);

		return null;
	}
};
